import { Select, SelectProps } from 'antd';
import cs from 'classnames';
import Styles from './Styles.module.scss';

type DefaultOptionType = NonNullable<SelectProps['options']>[number];

export function MPSelect<T = any, P extends DefaultOptionType = any>({ children, ...props }: IMPSelectProps<T>) {
    return (
        <>
            <Select<T, P>
                className={cs(Styles?.MPSelectContainer)}
                {...props}
            />
        </>
    );
}

export interface IMPSelectProps<T = any, P extends DefaultOptionType = any> extends SelectProps<T, P> {}
